module.exports = __webpack_public_path__ + "img/icon-building.a119c30b.svg";